"use client";

import { InformationCircleIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { ReactNode, useState } from "react";
import { trackEvent } from "./analytics-wrapper";
import { classNames } from "@/helpers/tailwind-class";

export function InfoDrawer({
  drawerId,
  label,
  content,
}: {
  drawerId: string;
  label: ReactNode;
  content: ReactNode;
}) {
  const [open, setOpen] = useState(false);

  return (
    <div className="drawer drawer-end">
      <input id={drawerId} type="checkbox" defaultChecked={open} className="drawer-toggle" />
      <div className="drawer-content">
        <label htmlFor={drawerId} className="drawer-button flex items-center gap-1">
          <div>{label}</div>

          <div
            className="btn btn-square btn-ghost btn-xs"
            onClick={() => {
              trackEvent({ eventName: "infoDrawerButton", action: "click" });
              setOpen(true);
            }}
          >
            <InformationCircleIcon className="size-5 cursor-pointer" />
          </div>
        </label>
      </div>
      <div className="drawer-side z-1000">
        <label
          htmlFor={drawerId}
          aria-label="close sidebar"
          className="drawer-overlay relative"
          onClick={() => setOpen(false)}
        >
          <div
            className={classNames(
              "btn btn-circle btn-outline absolute top-2 right-3/4 mr-2 transition-all sm:right-96",
              open ? "" : "hidden"
            )}
          >
            <XMarkIcon className="size-6" />
          </div>
        </label>
        <div className="flex h-screen w-[75%] items-center bg-slate-900 p-4 shadow-md sm:w-96">
          <div className="prose h-full w-full overflow-y-scroll py-16 text-slate-50">{content}</div>
        </div>
      </div>
    </div>
  );
}
